<template>
  <div class="content">
    <div class="mask searchFilter">
      <div class="search" style="background-color: rgb(255, 255, 255); position: fixed;">
        <div class="search-head">
          <div class="flex between align" style="width: 100%;">
            <a :href=indexurl style="display: contents;"><img class="logo" src="@/static/logo.jpg" alt /></a>
            <input v-model="where.name" type="search" placeholder="请输入咨询师的姓名" class="search-head-input" />
            <img
              @click="where.name = ''"
              :src="icon.close"
              class="fa fa-close clear"
              :style="{display: where.name === '' ? 'none' : ''}"
              alt
            />
            <span @click="search">
              <img :src="icon.search" class="searchFilter-searchImg" alt />
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="listFilter">
      <div class="bg-border">
        <div class="flex between listFilter-cell">
          <div v-for="(item, index) in filter.list" :key="index" class="flex align" @click="filter.show=true;filter.curren=index">
            <span
              :class="[(filter.show === true && filter.curren === index) || (!varAlike(filter.currentList[index], item.def)) ? 'clr-cyan' : '']"
            >{{ item.name }}</span>
            <img :src="filter.show === true && filter.curren === index ? icon.up : icon.down" class="listFilter-normal" alt />
          </div>
        </div>
        <template v-if="filter.show">
          <template v-for="(item, index) in filter.list">
            <div v-if="filter.curren === index && index === 0" class="flex" style="height: 410px;">
              <div v-for="(city,cityIndex) in filter.currentList[0]" class="item" style="overflow-y: scroll; max-height: 624rpx;">
                <div
                  class="city"
                  @click="$set(filter.currentList[0],cityIndex,0)"
                  :class="[filter.currentList[0][cityIndex] === 0 ? 'city-active' : '']"
                >不限</div>
                <div
                  v-if="cityIndex === 0 || filter.currentList[0][cityIndex - 1] !== 0"
                  v-for="(item, index) in cityData[cityIndex === 0 ? 86 : filter.currentList[0][cityIndex - 1]]"
                  :class="[filter.currentList[0][cityIndex] === index ? 'city-active' : '']"
                  :key="index"
                  @click="$set(filter.currentList[0],cityIndex,index)"
                  class="city"
                >{{ item }}</div>
              </div>
            </div>
            <div v-else-if="filter.curren === index && index === 3" class="pad-15" style="overflow-y: scroll; max-height: 624rpx;">
              <template v-for="(tag,tagIndex) in tagList">
                <span class="title">{{ tag.name }}</span>
                <div class="flex wrap">
                  <span
                    @click="$set(filter.currentList[index], tagList.id, !filter.currentList[index][tagList.id])"
                    :class="[filter.currentList[index][tagList.id] ? 'span-active' : '']"
                    v-for="(tagList, listIndex) in tag.list"
                    class="label-filter"
                  >{{ tagList.name }}</span>
                </div>
              </template>
            </div>
            <div v-else-if="filter.curren === index" class="flex pad-15">
              <span
                v-for="(label,labelIndex) in item.label"
                @click="$set(filter.currentList,index,labelIndex)"
                class="label-filter"
                :class="[ filter.currentList[index] === labelIndex ? 'span-active' : '']"
              >{{ label }}</span>
            </div>
          </template>
          <div class="flex between">
            <span class="btn-normal" @click="initSearch">重置</span>
            <span class="btn-normal btn-filter" @click="search">确定</span>
          </div>
        </template>
      </div>
      <div v-if="filter.show" @click="filter.show=false" class="filterMask" style="height: 100%;"></div>
    </div>
    <div class="listItem">
      <template v-if="list.length > 0">
        <div hover-class="none" @click="gopageInfo(item)" v-for="(item, index) in list" class="flex between list-item">
          <div>
            <div class="headImg-border">
              <img :src="item.avatar_sm_image" class="headImg" alt />
            </div>
            <div class="other clr-white fz-12">
              <span>{{ item.method.replace('video','视频').replace('onsite','面询').replace(',','和') }}</span>
            </div>
          </div>
          <div style="width: 100%">
            <div class="flex between">
              <div class="flex align">
                <span class="clr-black fz-16">{{ item.name }}</span>
                <img :src="Number(item.genderdata) === 1 ? icon.man : icon.girl" class="img-sex" alt />
              </div>
              <span class="clr-red fz-14">{{ item.price }}元/次</span>
            </div>
            <div class="flex between clr-simple fz-12 margin-12">
              <span>
                咨询经验
                <span class="clr-cyan">{{ item.exp }}+小时</span>
              </span>
              <div>
                <div>
                  {{ item.city.split('/',2)[0] }}
                  <span>·</span>
                  {{ item.city.split('/',2)[1] }}
                </div>
              </div>
            </div>
            <div class="intro" v-html="item.intro_content"></div>
            <div v-if="item.tag[3] && item.tag[3].length > 0" class="clr-simple fz-12 tag-list flex wrap">
              <span v-for="(tag,tagIndex) in item.tag[3]">
                <span class="tag">{{ tag.name }}</span>
              </span>
            </div>
          </div>
        </div>

        <infinite-loading :on-infinite="onInfinite" ref="infiniteLoading"> 
				
        <div slot="spinner">加载中...</div>//加载中的文字
        <div slot="no-more" style="color: #9999;">没有更多数据!</div>//加载完毕的文字
                  <div slot="no-results" style="color: #9999;">暂无更多数据</div>//没有数据的文字
      </infinite-loading>
      </template>

      <template v-else>
        <template v-if="empty">
          <img :src="icon.empty" class="list-none" alt />
          <div class="list-text">未找到符合条件的咨询师</div>
          <div class="list-text">请试试更换上方筛选条件</div>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import icon from '@/common/icon'
import ChineseDistricts from '@/common/ChineseDistricts'
import InfiniteLoading from 'vue-infinite-loading'
	
export default {
  components: {InfiniteLoading},
  data() {
    return {
      tagList: [],
      empty: false,
      indexurl:'',
      where: {
        name: '',
        gender: 0,
        price: '',
        city: '',
        tag: ''
      },
      page: 1,
      list: [],
      filter: {
        show: false,
        curren: 0,
        list: [
          {
            name: '城市',
            label: [],
            value: [],
            def: [0, 0, 0]
          },
          {
            name: '性别',
            label: ['不限', '男', '女'],
            value: [0, 1, 2],
            def: 0
          },
          {
            name: '价格',
            label: ['不限', '500及以下', '501-800', '801-1000', '1000以上'],
            value: ['', '0-501', '500-801', '800-1001', '1000'],
            def: 0
          },
          // {
          //   name: '其他',
          //   label: [],
          //   value: [],
          //   def: {}
          // }
        ],
        currentList: [[0, 0, 0], 0, 0, {}]
      }
    }
  },
  computed: {
    icon() {
      return icon
    },
    cityData() {
      return ChineseDistricts
    }
  },
  created() {
    this.$watch(
      'filter.currentList.3',
      (newVal, oldVal) => {
        for (let i in this.filter.currentList[3]) {
          if (this.filter.currentList[3][i] !== true) {
            delete this.filter.currentList[3][i]
          }
        }
      },
      {
        deep: true
      }
    )
    this.indexurl = this.$indexurl
    this.getTag()
    this.initData()
  },
  methods: {
    gopageInfo(item) {
      this.$router.push({
        path: '/info2',
        query: {
          id: item.id
        }
      })
    },
    onInfinite() {
					

          this.page++;
          this.getList()
  
          
  
          },
    async initData() {
      this.list = []
      this.page = 1
      await this.getList()
    },
    getTag() {
      this.$http.get('/index/getTag').then(res => {
        this.tagList = res.data.data
      })
    },
    getList() {
				console.log(this.where, this.page)
				this.$http.post('/index/list2', {
					where: this.where,
					page: this.page
				}).then(res => {
					// this.list = res.data.data.data
					this.list = this.list.concat( res.data.data.data);
					

					if (this.list.length <= 0 && res.data.data.data.length <= 0&&this.page==1) {
						this.empty = true
					}

          console.log(res.data.data.data.length)
					if(res.data.data.data.length<20){
            
						this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
					}else{
						this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
					
					}
				})
			},
    initSearch() {
      this.where.name = ''
      this.where = {
        name: '',
        gender: 0,
        price: '',
        city: '',
        tag: []
      }
      this.filter.currentList = [[0, 0, 0], 0, 0, {}]
    },
    varAlike(var1, var2) {
      if (typeof var1 == 'object' && typeof var2 == 'object') {
        return JSON.stringify(var1) === JSON.stringify(var2)
      }
      return var2 === var1
    },
    search() {
      this.where.gender = this.filter.list[1].value[this.filter.currentList[1]]
      this.where.price = this.filter.list[2].value[this.filter.currentList[2]]
      let city = []
      for (let i in this.filter.currentList[0]) {
        i = parseInt(i)
        let cityIndex = this.filter.currentList[0][i]
        if (cityIndex !== 0) {
          city.push(this.cityData[i === 0 ? 86 : this.filter.currentList[0][i - 1]][this.filter.currentList[0][i]])
        } else break
      }

      if (Object.keys(this.filter.currentList[3]).length > 0) {
        let tag = []
        Object.keys(this.filter.currentList[3]).map(r => this.filter.currentList[3][r] && tag.push(r))
        this.where.tag = tag.join(',')
      }

      this.where.city = city.join('/')
      this.filter.show = false
      this.initData()
    }
  }
}
</script>
<style>
@import url('../common/style.css');
</style>